import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import { sidebar_routes } from '../../routes';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';
import { TypeRoutes } from '../../routes/types';
import { FaAnglesRight } from 'react-icons/fa6';
import Arbitrator_new_logo_eng from '../../assets/images/new-logo-white.svg';
import Arbitrator_new_logo_ru from '../../assets/images/new-logo-ru-white.svg';
import Arbitrator_new_logo_uz from '../../assets/images/new-logo-uz-white.svg';

const { SubMenu } = Menu;

const Sidebar: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const active_path = location.pathname;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleOpenChange = (keys: string[]) => {
    setOpenKeys(keys);
  };

  const active_lang = localStorage.getItem('i18lang');

  const renderMenuItems = (routes: TypeRoutes[]) => {
    return routes.map((item) => {
      if (item.submenu && item.submenu.length > 0 && item?.config?.isMenu) {
        return (
          <SubMenu key={item.path} title={t(item.name)}>
            {renderMenuItems(item.submenu)}
          </SubMenu>
        );
      } else {
        return item.component ? (
          item?.config?.isMenu === true ? (
            <Menu.Item key={item.path} className='rounded-lg'>
              <Link to={item.path}>{t(item.name)}</Link>
            </Menu.Item>
          ) : null
        ) : null;
      }
    });
  };

  return (
    <div className="flex profile_sidebar">
      <div
        className={`fixed top-0 left-0 bg-main_color text-white w-80 min-h-screen p-4 transform ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-300 ease-in-out z-20 lg:relative lg:translate-x-0`}
      >
        <div className='flex justify-between items-center mt-12'>
          <img src={active_lang == 'uz' ? Arbitrator_new_logo_uz : active_lang == 'ru' ? Arbitrator_new_logo_ru : Arbitrator_new_logo_eng} alt="logo" className="object-cover" />
          <button className="lg:hidden absolute top-5 right-5" onClick={handleSidebarToggle}>
            <FaTimes size={24} />
          </button>
        </div>
        <h3 className='font-semibold mt-5 mb-7 pb-5 border-b border-[#79ACCB]'>{t('Main')}</h3>
        <Menu
          mode="inline"
          selectedKeys={[active_path]}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
          className='bg-transparent sidebar_menu'
          style={{ color: 'white',
            // height:"calc(100vh - 400px)",
            boxSizing:"border-box",
            overflowX:"auto"
           }}
        >
          {renderMenuItems(sidebar_routes.map(item => item))}
        </Menu>
      </div>
      <div className="h-screen flex items-center lg:hidden fixed z-10">
        <button
          className="py-2 px-1 bg-main_color text-white rounded-r-2xl"
          onClick={handleSidebarToggle}
        >
          {isSidebarOpen ? '': <FaAnglesRight size={20} />}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;

